import MainPage from "./dashboard.container";

export default MainPage;
